import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef, useState } from "react"

import api from "apis"

/**
 * Fetch ring sizing chart
 * @param  {array} sizeChart - ring sizing chart
 * @param  {object} averageRingSize - average ring size for women and men
 * @param {string} averageRingSize.women - average ring size for women
 * @param {string} averageRingSize.men - average ring size for men
 */
export default function fetchSizeChart(WrappedComponent) {
  const FetchSizeChart = ({ group_labels }) => {
    const [averageRingSize, setAverageRingSize] = useState({})
    const [sizeChart, setSizeChart] = useState([])
    const cancelled = useRef(false)

    const fetchSizeChart = useCallback(async () => {
      if (!cancelled.current && !sizeChart.length) {
        try {
          let url = "/api/v5/info/size_chart"
          if (group_labels) {
            url += `?group_labels=${group_labels}`
          }

          const result = await api.get(url)
          setSizeChart(result?.size_chart)
          setAverageRingSize(result?.average_ring_size)
        } catch (error) {
          console.log(error)
        }
      }
    }, [group_labels, sizeChart])

    useEffect(() => {
      fetchSizeChart()
    }, [fetchSizeChart])

    useEffect(() => {
      return () => (cancelled.current = true)
    }, [])

    if (!sizeChart.length) return null

    return <WrappedComponent {...{ averageRingSize, sizeChart }} />
  }

  FetchSizeChart.propTypes = {
    group_labels: PropTypes.string,
  }

  return FetchSizeChart
}
